// src/components/CollaborationsWidget.jsx
import React, { useEffect, useState } from 'react';
import { fetchJson, authHeaders } from '../api';

const GOLD = '#d4a550';
const GOLD_DIM = 'rgba(212,165,80,0.10)';
const GOLD_BORDER = 'rgba(212,165,80,0.28)';
const BORDER = 'rgba(255,255,255,0.07)';
const TEXT = '#e8e6df';
const TEXT_DIM = 'rgba(232,230,223,0.45)';
const SURFACE = '#0f0f17';
const BG_ITEM = '#13131e';

function fmtDate(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('it-IT', { month: 'short', year: 'numeric' });
}

export default function CollaborationsWidget({ freelancerUserId, token, companyName }) {
  const [collab, setCollab] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!freelancerUserId) return;
    (async () => {
      try {
        setLoading(true);
        const data = await fetchJson(`/freelancers/${freelancerUserId}/collaborations`, {
          headers: authHeaders(token)
        });
        setCollab(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, [freelancerUserId, token]);

  return (
    <div style={{ background: SURFACE, border: `1px solid ${collab.length > 0 ? GOLD_BORDER : BORDER}`, borderRadius: 10, padding: '12px 14px', fontFamily: "'Inter', sans-serif" }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: collab.length > 0 ? 10 : 0 }}>
        <span style={{ fontSize: 13 }}>🤝</span>
        <span style={{ fontSize: 10, fontFamily: "'Kanit', sans-serif", fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: GOLD }}>
          Storico collaborazioni
        </span>
        {collab.length > 0 && (
          <span style={{ fontSize: 10, fontWeight: 700, padding: '1px 7px', borderRadius: 20, border: `1px solid ${GOLD_BORDER}`, background: GOLD_DIM, color: GOLD, marginLeft: 'auto' }}>
            {collab.length}
          </span>
        )}
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', color: TEXT_DIM, fontSize: 11, padding: '6px 0' }}>...</div>
      ) : collab.length === 0 ? (
        <div style={{ fontSize: 11, color: '#444', marginTop: 4 }}>
          Nessuna collaborazione precedente{companyName ? ` con ${companyName}` : ''}.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {collab.slice(0, 4).map(c => (
            <div key={c.id} style={{ padding: '8px 10px', borderRadius: 6, background: BG_ITEM, border: `1px solid ${BORDER}` }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 600, color: TEXT, marginBottom: 2 }}>{c.produzione}</div>
                  <div style={{ fontSize: 11, color: TEXT_DIM }}>{c.ruolo} · {fmtDate(c.data_inizio_contratto)} → {fmtDate(c.data_fine_contratto)}</div>
                </div>
                <span style={{ fontSize: 10, padding: '2px 7px', borderRadius: 20, border: `1px solid ${BORDER}`, color: TEXT_DIM, flexShrink: 0 }}>{c.azienda}</span>
              </div>
            </div>
          ))}
          {collab.length > 4 && (
            <div style={{ fontSize: 11, color: '#555', textAlign: 'center', paddingTop: 2 }}>
              e altre {collab.length - 4} collaborazioni precedenti
            </div>
          )}
        </div>
      )}
    </div>
  );
}
